import React from 'react';
import T from 'prop-types';
// styles
import classnames from 'classnames';
import './PigsUnderTreatmentLine.scss';
// translate
import { FormattedMessage } from 'react-intl';

const PigsUnderTreatmentLine = ({ pigsCount, className, mobile }) => (
  <div className={classnames(`PigsUnderTreatmentLine ${className}`, { 'mobile': mobile })}>
    <span className="left-value">
      <span className="icon fa fa-ep-piggy" />
      <FormattedMessage id="general.ptg" />
    </span>
    <span><strong>{pigsCount || 0}</strong></span>
  </div>
);

PigsUnderTreatmentLine.propTypes = {
  pigsCount: T.number,
  className: T.string,
  mobile: T.bool,
};

PigsUnderTreatmentLine.defaultProps = {
  className: '',
};

export default PigsUnderTreatmentLine;
